export default [
    {
        path: '/informe-movimiento/index',
        name: 'InformeMovimientoView',
        component: () => import('../views/informe/InformeMovimientoView.vue')
    },
    {
        path: '/informe-inspeccion/index',
        name: 'InformeInspeccionView',
        component: () => import('../views/informe/InformeInspeccionView.vue')
    },
    {
        path: '/informe-inspeccion-cliente/index',
        name: 'InformeInspeccionClienteView',
        component: () => import('../views/informe/InformeInspeccionClienteView.vue')
    },
    {
        path: '/informe-estado-poliza/index',
        name: 'InformeEstadosPolizaView',
        component: () => import('../views/informe/InformeEstadosPolizaView.vue')
    },
    {
        path: '/informe-servicio-complementario/index',
        name: 'InformeServicioComplementarioView',
        component: () => import('../views/informe/InformeServicioComplementarioView.vue')
    },
    {
        path: '/informe-liquidacion-comision/index',
        name: 'InformeLiquidacionComisionView',
        component: () => import('../views/informe/InformeLiquidacionComisionView.vue'),
    }, 
    {
        path: '/informe-liquidacion/index',
        name: 'InformeLiquidacionView',
        component: () => import('../views/informe/InformeLiquidacionView.vue'),
    },
    {
        path: '/informe-beneficio-complementario/index',
        name: 'InformeBeneficioComplementarioView',
        component: () => import('../views/informe/InformeBeneficioComplementarioView.vue'),
    },
    {
        path: '/informe-poliza-renovar/index',
        name: 'InformePolizaRenovarView',
        component: () => import('../views/informe/InformePolizaRenovarView.vue'),
    },
    {
        path: '/informe-poliza-tradicional/index',
        name: 'InformePolizaTradicionalView',
        component: () => import('../views/informe/InformePolizaTradicionalView.vue'),
    },
]